import styled, { css } from 'styled-components';

export const Cta = styled.button<{ isClear?: boolean; isActive?: boolean; isDisabled?: boolean }>`
  background-color: ${({ theme }) => theme.kallisto.color.background.static.backgroundBrandPrimary};
  color: #fff;
  height: 40px;
  line-height: 40px;
  font-size: ${({ theme }) => theme.kallisto.font.size['175']};
  font-weight: ${({ theme }) => theme.kallisto.font.weight.bold};
  border-radius: 6px;
  min-width: 140px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  ${({ isClear }) =>
    !isClear &&
    css`
      padding: 10px 16px;
    `}

  ${({ isClear }) =>
    isClear &&
    css`
      background-color: #fff;
      color: ${({ theme }) => theme.kallisto.color.text.interactive.textPrimaryDefault};
    `}

  ${({ isClear, isDisabled }) =>
    isClear &&
    isDisabled &&
    css`
      background-color: #fff;
      color: ${({ theme }) => theme.kallisto.color.common.black[200]};
      cursor: default;
    `}

  ${({ isActive }) =>
    isActive &&
    css`
      color: ${({ theme }) => theme.kallisto.color.text.interactive.textPrimaryDefault};
    `}

  ${({ isClear, isDisabled }) =>
    !isClear &&
    isDisabled &&
    css`
      background-color: ${({ theme }) => theme.kallisto.color.common.black[100]};
      border-color: ${({ theme }) => theme.kallisto.color.common.black[100]};
      color: ${({ theme }) => theme.kallisto.color.common.black[200]};
      cursor: default;
    `}
`;
